
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiThreewayAnalogInleftRight50 as ObiThreewayAnalogInleftRight50Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-threeway-analog-inleft-right-50.js';
 
 
 

 
 export const ObiThreewayAnalogInleftRight50 = createComponent({
   react: React,
   tagName: 'obi-threeway-analog-inleft-right-50',
   elementClass: ObiThreewayAnalogInleftRight50Element,
   events: {
     
   }
  });
 
 